import { LoginScreen } from './auth/LoginScreen';
import { IntentionScreen } from './intention/IntentionScreen';
import { LandingScreen } from './landing/LandingScreen';
import { openReaderScreen } from './reader/openReaderScreen';
import { mountExtractedScreen } from '../legacy/screenHost';

/**
 * Takes ownership of the screens React has extracted by overwriting their
 * legacy window bindings — classic-script function declarations resolve
 * through the global object, so every legacy caller (route(), doLogout(),
 * the language-sheet rerender, login's back button) transparently invokes
 * the React implementation.
 *
 * Called from useLegacyRuntime immediately after app.js loads and before
 * its boot promise can call route(), so even the first paint goes through
 * React.
 */
export function installExtractedScreens(): void {
  window.screenLanding = () => mountExtractedScreen(<LandingScreen />);
  window.screenLogin = () => mountExtractedScreen(<LoginScreen />);
  window.screenIntention = (opts) => mountExtractedScreen(<IntentionScreen onDone={opts?.onDone} />);
  /* SCREEN 4: every legacy caller — goToNextPage's default, the tour, the settings
     sheets of both readers — resolves openReader through the window binding */
  window.openReader = (opts) => { void openReaderScreen(opts); };
}
